
import axios from "../api/axiosInstance";

export const getProductInfo = () => {
  return axios.get("/Product/GetAllProduct");
};

export const getProductGroupInfo = () => {
    return axios.get("/Product/GetAllProductGroup");
  };

  export const getProductByProductGroup = (productGroupId) => {
    return axios.get(`/Product/GetProductByProductGroup?productGroupId=${productGroupId}`);
  };
